module.exports = __webpack_public_path__ + "cdf590230a4b5305c6ef0b9ee0bea69b.png";